import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import s from "../components/ReplaceCompanyCsvConfirmModal.module.css";

interface DiscardCompanyChangesConfirmModalProps {
  isOpen: boolean;
  onStay: () => void;
  onDiscard: () => void;
}

/** Confirms abandoning the local, not-yet-saved whole-company draft. */
export function DiscardCompanyChangesConfirmModal({
  isOpen,
  onStay,
  onDiscard,
}: DiscardCompanyChangesConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          Discard company changes?
        </Heading>
        <p className={s.message}>
          Changes made since you opened this company will be lost.
        </p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onStay}>
              Stay
            </Button>
            <Button variant="tertiary" onPress={onDiscard}>
              Discard
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
